module.exports = __webpack_public_path__ + "img/apm_test_nuvei.c542a07.svg";